<!--OVERVIEW SECTION CARDS-->
@if (
  kydEligible ||
  (showKydSmartphoneCard | async) ||
  (showAutopayCard | async) ||
  (showPaperlessCard | async) ||
  showMMWDMWCard
) {
  <ds-overview-section
    class="overview-section--programs"
    [loading]="loading | async"
    [spinnerTextPath]="'overview.programs.spinnerText'"
    [newDesign]="true"
  >
    <!-- NEW TILES START -->
    <ds-overview-section-content>
      @if (!(loading | async)) {
        <div class="row overview-section--programs-container pad-bottom-60 pad-top-10 text-center">
          <div class="overview-section--programs-title-icon">
            <img src="/assets/images/dollar-sign_doodle_dashboard.svg" alt="program dollar icon" />
          </div>
          <div
            class="text-center pad-top-24 font-size-1-75 font-weight-semibold color-white"
            dsContent
            [contentPath]="'overview.programs.heading'"
          ></div>
          <div
            class="text-center pad-top-16 pad-bottom-40 font-size-1 font-weight-normal color-light-gray"
            dsContent
            [contentPath]="'overview.programs.subheading'"
          ></div>
          @if (!(loading | async)) {
            <div class="row borderless tiles justify-center">
              @if (showPaperlessCard | async) {
                <div class="column pad-bottom twelve md-four --programs">
                  <amfam-set-billing-and-policy-preferences
                    [billingEligibleToGoPaperless$]="billingEligibleToGoPaperless$"
                    [isPolicyGoPaperless$]="isPolicyGoPaperless$"
                    [routeToConfirmation]="true"
                    class="paperless-height"
                  >
                  </amfam-set-billing-and-policy-preferences>
                </div>
              }
              <!-- Card to setup multiple autopay with single click -->
              @if (showAutopayCard | async) {
                <div class="column pad-bottom twelve md-four --programs">
                  <ds-autopay-overview-card
                    data-cy="autoPayOverviewCard"
                    [buttonAnalyticData]="multiAutopayOverviewAnalytic"
                    (ctaClickEvent)="navigateToAutopaySetupPage()"
                  ></ds-autopay-overview-card>
                </div>
              }
              @if (showKydSmartphoneCard | async) {
                <div class="column pad-bottom twelve md-four --programs">
                  <ds-tile class="program-tile">
                    <div class="tile-heading" tile-heading>
                      <div class="heading-text">
                        <!-- Icon & Headline -->
                        <div class="flex items-center">
                          <em class="heading-icon icon-mobile-phone"></em>
                          <span
                            class="heading-section"
                            dsContent
                            [contentPath]="'overview.programs.kydHeading'"
                          ></span>
                        </div>
                        @if (!(isNotEnrolledKydSmartphone | async)) {
                          <p>
                            {{ content.kydSmartphoneCardEnrolled }}
                          </p>
                        }
                        @if (isNotEnrolledKydSmartphone | async) {
                          <p>
                            {{ content.kydSmartphoneCardNotEnrolled }}
                          </p>
                        }
                      </div>
                    </div>
                    <div tile-cta class="tile-cta">
                      <button
                        [attr.aria-label]="
                          (isNotEnrolledKydSmartphone | async) ? 'Enroll' : 'Manage Enrollment'
                        "
                        ds-button
                        dsRouterLink="/policies/knowyourdrivesmartphone"
                      >
                        {{ (isNotEnrolledKydSmartphone | async) ? 'Enroll' : 'Manage Enrollment' }}
                      </button>
                    </div>
                  </ds-tile>
                </div>
              }
              @if (showKYDManageEnrollmentDuringMigration$ | async) {
                <div class="column pad-bottom twelve md-four --programs">
                  <ds-tile class="program-tile">
                    <div class="tile-heading" tile-heading>
                      <div class="heading-text">
                        <!-- Icon & Headline -->
                        <div class="flex items-center">
                          <em class="heading-icon icon-mobile-phone"></em>
                          <span
                            class="heading-section"
                            dsContent
                            [contentPath]="'overview.programs.kydHeading'"
                          ></span>
                        </div>
                        {{ content.kydSmartphoneCardEnrolled }}
                      </div>
                    </div>
                    <div tile-cta class="tile-cta">
                      <button
                        [attr.aria-label]="'Manage Enrollment'"
                        ds-button
                        dsRouterLink="/policies/knowyourdrivesmartphone"
                        dsContent
                        [contentPath]="'overview.programs.manageEnrollment'"
                      ></button>
                    </div>
                  </ds-tile>
                </div>
              }
              <!-- AMFAM UI Component : Card : MMW Start -->
              @if (showMMWDMWCard) {
                <div class="column pad-bottom twelve md-four --programs">
                  <ds-amfam-dsn-card
                    [icon]="true"
                    [iconName]="'icon-odometer'"
                    [title]="mmwCardEnrolledTitle"
                    [message]="mmwCardEnrolledMessage"
                    [primaryButtonName]="'Learn More'"
                    (primaryButtonEvent)="learnMoreBtn('mmw')"
                  ></ds-amfam-dsn-card>
                </div>
              }
              <!-- AMFAM UI Component : Card : MMW End -->
              <!-- AMFAM UI Component : Card : DMW Start -->
              @if (showMMWDMWCard) {
                <div class="column pad-bottom twelve md-four --programs">
                  <ds-amfam-dsn-card
                    [icon]="true"
                    [iconName]="'icon-amfam-misc-steering-wheel-fill-1'"
                    [title]="dmwCardEnrolledTitle"
                    [message]="dmwCardEnrolledMessage"
                    [primaryButtonName]="'Learn More'"
                    (primaryButtonEvent)="learnMoreBtn('dmw')"
                  ></ds-amfam-dsn-card>
                </div>
              }
              <!-- AMFAM UI Component : Card : DMW End -->
              @if (kydEligible) {
                <div class="column pad-bottom twelve md-four --programs">
                  <ds-tile class="program-tile">
                    <div class="tile-heading" tile-heading>
                      <div class="heading-text">
                        <!-- Icon & Headline -->
                        <div class="flex items-center">
                          <em class="heading-icon icon-mobile-phone"></em>
                          <span
                            class="heading-section"
                            dsContent
                            [contentPath]="'overview.programs.kydHeading'"
                          ></span>
                        </div>
                        <p>{{ content.kydCardNotEnrolled }}</p>
                      </div>
                    </div>
                    <div tile-cta class="tile-cta">
                      <a
                        class="button"
                        dsRouterLink="/policies/knowyourdrive"
                        dsContent
                        [contentPath]="'overview.programs.enroll'"
                      ></a>
                    </div>
                  </ds-tile>
                </div>
              }
            </div>
          }
        </div>
      }
      <ds-policy-terms-and-conditions [(visible)]="showModal"></ds-policy-terms-and-conditions>
      <ds-overview-registration-modal
        [(visible)]="showRegistrationModal"
        (tryAgainEvent)="goPaperLess()"
      >
      </ds-overview-registration-modal>
    </ds-overview-section-content>
    <!-- NEW TILES END -->
  </ds-overview-section>
}
